import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiFetch } from '../../../../apiFetch';
import './ApplyForm.css';

const ApplyForm = () => {
  const { opportunityId } = useParams();
  const navigate = useNavigate();
  const [playerId, setPlayerId] = useState(null);
  const [introduction, setIntroduction] = useState('');
  const [cvFile, setCvFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [profileSlug, setProfileSlug] = useState(null);

  const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

  useEffect(() => {
    const storedId = localStorage.getItem('playerId');
    const storedSlug = localStorage.getItem('playerProfileSlug'); // ✅ must be set at login

    if (storedId) {
      setPlayerId(parseInt(storedId, 10));
    } else {
      alert('Player ID not found. Please log in again.');
      navigate('/login');
      return;
    }

    if (storedSlug) {
      setProfileSlug(storedSlug);
    } else {
      alert('Profile slug not found. Please log in again.');
      navigate('/login');
      return;
    }
  }, [navigate]);

  const handleFileChange = (e) => {
    setCvFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!playerId) {
      alert('Error: Player ID is missing.');
      console.error('❌ playerId is undefined at submission time.');
      return;
    }

    if (!profileSlug) {
      alert('Error: Profile slug is missing.');
      console.error('❌ profileSlug is undefined at submission time.');
      return;
    }

    if (!FRONTEND_URL) {
      alert('Config error: FRONTEND_URL is missing.');
      console.error('❌ FRONTEND_URL missing in env.');
      return;
    }

    if (!introduction.trim()) {
      alert('Please enter your introduction.');
      return;
    }

    console.log('✅ Submitting with:', {
      playerId,
      opportunityId,
      introduction,
      profileLink: `${FRONTEND_URL}/player-profile/${profileSlug}`,
      cvFile
    });

    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('playerId', playerId);
      formData.append('opportunityId', parseInt(opportunityId, 10));
      formData.append('introduction', introduction);
      formData.append('profileLink', `${FRONTEND_URL}/player-profile/${profileSlug}`);
      if (cvFile) {
        formData.append('cv', cvFile);
      }

      const response = await apiFetch('/api/apply', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        alert('Application submitted successfully!');
        navigate('/player-dashboard');
      } else {
        const errorData = await response.json();
        alert(errorData.error || 'Something went wrong');
      }
    } catch (err) {
      console.error('❌ Application error:', err);
      alert('Server error. Please try again later.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="apply-form-container">
      <h2 className="apply-form-title">Apply for Opportunity</h2>
      <form onSubmit={handleSubmit} className="apply-form">
        <label htmlFor="introduction">Brief Introduction & Motivation</label>
        <textarea
          id="introduction"
          value={introduction}
          onChange={(e) => setIntroduction(e.target.value)}
          rows={6}
          placeholder="Explain who you are and why you're applying..."
        />

        <label htmlFor="cv">Upload CV (optional)</label>
        <input
          id="cv"
          type="file"
          accept=".pdf,.doc,.docx"
          onChange={handleFileChange}
        />

        <p className="note">Your Player Profile Link will be attached automatically.</p>

        <button type="submit" className="submit-button" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit Application'}
        </button>
      </form>
    </div>
  );
};

export default ApplyForm;

